import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { v4 as uuidv4 } from "uuid";

import { fetchPost } from "../../api/fetch";

import Dialog from "@material-ui/core/Dialog";

import Loader from "../Common/Loader";
import AddIcon from "../Common/AddIcon";
import AddPhotos from "./AddProfile/AddPhotos";

import colors from "../../assets/style/colors";

const styles = {
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    //width: "400px",
    maxWidth: "1280px",
    maxHeight: "calc(100vh - 100px)",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px 24px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1em",
    margin: "20px",
    color: colors.black54,
  },
  postCreationBtn: {
    margin: "10px 0px",
  },
  titleBarItem: {
    display: "flex",
    alignItems: "center",
  },
};

const UploadPhotos = (props) => {
  const { classes, profileId, onUpload } = props;
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [photos, setPhotos] = React.useState([]);

  const closeDialog = () => {
    setPhotos([]);
    setOpen(false);
  };

  const savePhotos = async () => {
    setLoading(true);
    try {
      for (let i = 0; i < photos.length; i++) {
        let body = {
          name: uuidv4(),
          enrollment_status: false,
          enrollment_error: false,
          main_display: false,
          "image-base64": photos[i],
        };
        await fetchPost(`profiles/${profileId}/images`, body);
        console.log("image added to profile");
      }
      setPhotos([]);
    } catch (e) {
      console.log(e);
    }
    onUpload();
    setLoading(false);
    setOpen(false);
  };

  //   const saveAndEnroll = async () => {
  //     try {
  //       setStep(ENROLLING);
  //       await savePhotos(false);
  //       await fetchPost(`profiles/${createdProfile.id}/index`, {}, API_LUKE);
  //       let indexationResult = await fetchGet(
  //         `profiles/${createdProfile.id}/index`,
  //         API_LUKE
  //       );
  //       console.log(indexationResult);
  //       if (
  //         indexationResult &&
  //         indexationResult.data &&
  //         indexationResult.data.completed !== undefined
  //       ) {
  //         if (indexationResult.data.completed === true) {
  //           setStep(ENROLLMENT_DONE);
  //         } else {
  //           setStep(ENROLLMENT_FAILED);
  //         }
  //       }
  //     } catch (e) {
  //       console.log(e);
  //       setStep(ENROLLMENT_FAILED);
  //     }
  //   };

  return (
    <>
      <AddIcon handleClick={() => setOpen(true)} disabled={props.disabled} />
      <Dialog
        open={open}
        classes={{
          root: classes.dialogRoot,
          paperScrollPaper: classes.dialog,
        }}
      >
        {loading ? (
          <Loader
            height="340px"
            width="380px"
            message={I18n.get("profiles_savingPhotos")}
          />
        ) : (
          <AddPhotos
            photos={photos}
            setPhotos={setPhotos}
            savePhotos={savePhotos}
            close={closeDialog}
            classes={classes}
            onlySave={true}
          />
        )}
      </Dialog>
    </>
  );
};

UploadPhotos.propTypes = {
  profileId: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
};

export default withStyles(styles)(UploadPhotos);
